// Single source of truth for the "portrait mobile" layout switch. Below this
// width, in portrait, the desktop chrome (top app bar + left navigation
// drawer) is replaced by MobileNavigation's top/bottom bars. Keep every
// consumer on this helper so the wireframe and the pages can never disagree
// about which chrome to render.
export const FORCED_COMPACT_MAX_WIDTH = 960;

export const isPortraitMobile = ({ width, height } = {}) =>
  width <= FORCED_COMPACT_MAX_WIDTH && height > width;
